import { memo } from "react";

import styled from "styled-components";

import Button from "@mui/material/Button";

import openHelpScout from "../../../../../utility/helpscout";

// -----------------------------------------------------------------------------

export const LoginErrorContactButton = memo(
  function LoginErrorContactButton(): JSX.Element {
    return (
      <>
        please{" "}
        <ErrorButton
          disableRipple
          disableFocusRipple
          color="primary"
          variant="text"
          onClick={launchHelp}
        >
          contact us
        </ErrorButton>{" "}
        at support@threatkey.com for assistance.
      </>
    );
  }
);

// -----------------------------------------------------------------------------

function launchHelp(e: React.MouseEvent<HTMLButtonElement>) {
  e.preventDefault();
  openHelpScout();
}

// -----------------------------------------------------------------------------

const ErrorButton = styled(Button)`
  font-size: inherit;
  line-height: 1;
  padding: 0;
  text-transform: lowercase;
  vertical-align: inherit;
  display: inline;

  &:hover {
    background: none;
  }
`;
